import { BadgeCheck, Sparkles, CheckCircle2, XCircle } from "lucide-react";

export function AdConnectionBadge({ connection, loading, error, testId }) {
  const failed = Boolean(connection?.accounts_error || connection?.pages_error);
  const connected = connection?.status === "connected";
  const incomplete = connection?.id === "meta" && connected && !connection?.publish_ready;
  const ready = !loading && !error && !failed && connected && !incomplete;
  const label = loading ? "Verifica in corso…" : error || !connection ? "Stato non disponibile"
    : failed ? "Verifica non riuscita" : incomplete ? "Da completare"
    : connected ? "Collegato" : connection.status === "pending" ? "Scegli account" : "Non collegato";
  const color = ready ? "text-emerald-300"
    : error || failed || incomplete || connection?.status === "pending" ? "text-amber-300" : "text-slate-500";
  const Icon = ready ? CheckCircle2 : XCircle;
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] font-semibold ${color}`} data-testid={testId}>
      <Icon size={13} />{label}
    </span>
  );
}

export function DataBadge({ variant = "real", className = "" }) {
  const isReal = variant === "real";
  const Icon = isReal ? BadgeCheck : Sparkles;
  const label = isReal ? "Dati reali" : "Stima Nadia";
  const style = isReal
    ? "bg-emerald-500/10 text-emerald-300 border-emerald-500/20"
    : "bg-violet-500/10 text-violet-300 border-violet-500/25";
  return (
    <span
      data-testid={`data-badge-${variant}`}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wider border ${style} ${className}`}
    >
      <Icon size={11} strokeWidth={2.5} />
      {label}
    </span>
  );
}

export function AutonomyPill({ level }) {
  const cls =
    level === "CONSIGLIA"
      ? "pill-consiglia"
      : level === "PREPARA"
      ? "pill-prepara"
      : "pill-esegue";
  return (
    <span
      data-testid={`autonomy-pill-${level?.toLowerCase()}`}
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-[10px] font-semibold uppercase tracking-wider ${cls}`}
    >
      {level}
    </span>
  );
}
